import { Company } from '../../pp/dto/Company';
import { CompanyAndStage } from '../../../core/service/company-utils/company-utils';
import { EmployeeCrudDTO } from './EmployeeCRUDDTO';
import { CompanyWithRoundsDTO } from './CompanyWithRoundsDTO';
import { CompanyMiniDto } from '../../recovery/component/recovery-company/dto/CompanyWithOrgDto';
import { StockDTO } from '../../company-performance/companies-stocks/dto/StockDTO';

export enum CompanyStages {
  NO_VALUE = '-',
  RND = 'R&D',
  SALES = 'Launching sales',
  REVENUE = 'Revenue',
}

export interface CompanyStageForBackEnd {
  uuid: string;
  stage: CompanyStages;
}

export interface ResponsibleManagerForBackEnd {
  companyUUID: string;
  managerUUIDs: string[];
}

export interface OrganizationEmployeeMiniDTO {
  item: string;
  UUID: string;
  chosen: boolean;
}

export interface CompanyCRUDEmitter {
  body: Company | CompanyAndStage | string[] | void;
  action: COMPANY_CRUD_ACTION;
}

export enum COMPANY_CRUD_ACTION {
  BULK_UPLOAD,
  BULK_DELETE,
  UPDATE,
  UPDATE_COMPANY_STAGE,
  DELETE,
  CREATE,
  COPY,
  NONE
}

export interface EmployeeCRUDEmitter {
  body: EmployeeWrapper | EmployeeCrudDTO;
  action: EmployeeCRUDAction;
}

export interface EmployeeWrapper {
  employee: EmployeeCrudDTO;
  companyName: string;
}

export enum EmployeeCRUDAction {
  UPDATE,
  CREATE,
  DELETE
}

export interface CompanyFromCrudModalWrapper {
  company: Company | CompanyWithRoundsDTO;
  action: COMPANY_CRUD_ACTION;
  companyToBeCopiedFrom?: CompanyMiniDto;
}

export class StockBulkUpdateDto {
  toBeDeleted: StockDTO[] = [];
  toBeAdded: StockDTO[] = [];
}

export interface CompanyIndustryAndDescUpdateDto {
  uuid: string;
  description: string;
  industry: string;
}
